export const CONFIG_CONTAINER_GUIDE = 'https://w.amazon.com/bin/view/EFPCore/Projects/CreateConfigContainerGuide/';
export const CONFIG_SCHEMA_GUIDE = 'https://w.amazon.com/bin/view/Users/sdabral/Quip/CreateUpdateConfigSchemaGuide/';